import { ref } from 'vue'

const isOpen = ref(false)

export function useRenewAuthorisationModal() {
  const openRenewAuthorisationModal = () => {
    isOpen.value = true
  }

  const closeRenewAuthorisationModal = () => {
    isOpen.value = false
  }

  return {
    isOpen,
    openRenewAuthorisationModal,
    closeRenewAuthorisationModal,
  }
}
